<template>
    <div class="con">
        <div class="one">
         <div class="mCon">
         <div class="left">
             <img src="../assets/azf/fLogo.png" alt="">
         </div>
             <div class="center">
                 <p></p>
                 <p>
                   <span>{{$t('foot').text7}}</span> {{$t('foot').text0}}<br>
                     <span>{{$t('foot').text8}}</span>  {{$t('foot').text2}}<br>
                     <span>{{$t('foot').text9}}</span> {{$t('foot').text3}}<br>
                     <span>{{$t('foot').text10}}</span>{{$t('foot').text4}}
<!--                     {{$t('foot').text1}}<br>-->
                 </p>
             </div>
             <div class="right">
<!--                 <p>-->
<!--                     <span>{{$t('foot').text8}}</span>  {{$t('foot').text2}}<br>-->
<!--                     <span>{{$t('foot').text9}}</span> {{$t('foot').text3}}<br>-->
<!--                     <span>{{$t('foot').text10}}</span>{{$t('foot').text4}}-->
<!--                 </p>-->
             </div>
         </div>
        </div>
        <div class="two">
            <div class="mCon">
                <a href="https://beian.miit.gov.cn/" target="_blank">{{$t('foot').text5}}</a>
                <a href="https://www.sansg.com/">{{$t('foot').text6}}</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "foot",
        data(){
            return{
            }
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    .one{
        width:100%;
        background-color: #F4F6F9;
        .mCon{
            width:1440px;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 60px 0;
            .left{
                padding-top: 60px;
            }
            .center{
                p{
                    span{
                        font-weight: bolder;
                        font-family: "Microsoft YaHei";
                    }
                }
                p:nth-child(1){
                    font-size: 20px;
                    font-family: "Fira Code Medium";
                    font-weight: lighter;
                    padding-bottom: 30px;
                }
                p:nth-child(2){
                    color:#5C5C5C;
                    font-family: "Microsoft YaHei UI Light";
                    line-height: 40px;
                    font-size: 14px;
                }
            }
            .right{
                padding-top: 30px;
                p{
                    color:#5C5C5C;
                    font-family: "Microsoft YaHei UI Light";
                    line-height: 40px;
                    font-size: 14px;
                    span{
                        font-weight: bolder;
                        font-family: "Microsoft YaHei";
                    }
                }
            }
        }
    }
    .two{
        width:100%;
        background-color: #323232;
        .mCon{
            width:1440px;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 20px 0;
            p,a{
                color:#C1C1C1;
                font-size: 14px;
                font-family: "Microsoft YaHei UI Light";
            }
            a{
                transition: all 1s;
            }
            a:hover{
                color:#67B233;
            }
        }
    }
    @media screen and (max-width: 1440px) and (min-width: 1000px){
        .one,.two{
            .mCon{
                width:90%;
            }
        }
    }
    @media screen and (max-width: 999px){
        .one,.two{
            .mCon{
                width:95%;
                flex-direction: column;
                align-items: center;
            }
        }
        .one{
            .mCon{
                padding-bottom: 30px;
                .left,.right{
                    padding-top: 0;
                }
            }
        }
        .center{
            p:nth-child(2){
                text-align: center;
                font-size: 13px;
            }
        }
        .two{
            .mCon{
                p{
                    line-height: 30px;
                }
            }
        }
    }
}
</style>
